import React, { useContext, useState } from 'react';

import { UserItemContext } from 'src/lib/UserItemContext';
import { LoginContext } from 'src/lib/LoginContext';
import { IAuctionItem } from 'src/pages/CatalogPage/CatalogPage.i';
import { useOverlayTriggerState } from '@react-stately/overlays';
import { TextAlertModal } from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItemActions/CatalogTextAlerts/TextAlertModal/TextAlertModal';
import { Button, cn, Typography } from '@riac/design-system';

interface ICatalogTextAlerts {
  item: IAuctionItem;
  className?: string;
}

export const CatalogTextAlerts = (props: ICatalogTextAlerts) => {
  const { isLoggedIn } = useContext(LoginContext);
  const { auctionTextAlerts } = useContext(UserItemContext);
  const [alertAdded, setAlertAdded] = useState(false);

  const textAlertModalOverlayState = useOverlayTriggerState({});

  const alertSet
    = auctionTextAlerts.filter((alert) => alert.LotNumber === props.item.LotNumber).length > 0;

  //alertSet and alertAdded basically mean the same thing.
  //this should probably be the default value of the state instead of a separate property.
  //but i'm not changing it now because it works and i don't want to break anything.

  function toggleViewTextAlert() {
    if(!isLoggedIn || alertSet || alertAdded) return;
    textAlertModalOverlayState.open();
  }

  return (
    <>
      <div className='flex flex-col gap-1'>
        <Typography color='text-lighter' size='xs'>
          {(alertSet || alertAdded) && (<>
            {alertAdded && 'Added text alert' || 'Text alert active'}
            {' - '}
            <Button
              variant='text'
              className='p-0'
              to='/account/textalerts'
            >
              Manage
            </Button>
          </>) || (<>
            <Button
              variant='text'
              className='p-0'
              onPress={(alertSet || alertAdded) ? undefined : toggleViewTextAlert}
            >
              Add Text Reminder
            </Button>
          </>)}
        </Typography>
      </div>
      {textAlertModalOverlayState.isOpen && (
        <TextAlertModal
          item={props.item}
          closeModal={() => textAlertModalOverlayState.close()}
          addAlert={() => setAlertAdded(true)}
        />
      )}
    </>
  );
};
